import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IMyHomeV2Schema } from '../../repositories/price-estimator/entities/card/MyHomeV2Schema';

export enum EActionTypes {
  SetRealtyList = 'myHome/setRealtyList',
}

export const setRealtyList = actionGenerator<EActionTypes.SetRealtyList, IMyHomeV2Schema[]>(EActionTypes.SetRealtyList);

export type TMyHomeActions = ReturnType<typeof setRealtyList>;
